import find from "lodash/fp/find";
import flatMap from "lodash/fp/flatMap";
import flow from "lodash/fp/flow";
import getOr from "lodash/fp/getOr";

import selectUserChoices from "./selectUserChoices";
import { shouldBeDisplayed } from "utils";
import selectUserChoiceValues from "./selectUserChoiceValues";
import { filter, map } from "lodash/fp";

export default function selectProductBadgeImages(state) {
  const { selectedCustomisationId, selectedProductId } = state.app;
  const userChoices = selectUserChoices(state);
  const userChoiceValues = selectUserChoiceValues(state);

  return flow(
    getOr([], ["app", "formData", "products"]),
    find(({ id }) => id === selectedProductId),
    getOr([], ["customisations"]),
    find(({ id }) => id === selectedCustomisationId),
    getOr([], ["fields"]),
    flatMap((field) => {
      const { name, imageBadgePosition } = field;

      // If the field has fieldImageBadges, use those for all options
      if (field.fieldImageBadges) {
        return flow(
          filter(shouldBeDisplayed(userChoiceValues)),
          map((imageBadge) => ({
            ...imageBadge,
            video: imageBadge.video || field.video || null,
            position: imageBadgePosition,
          }))
        )(field.fieldImageBadges);
      }

      const {
        label,
        imageBadges = [],
        details = [],
        video = {},
        position = {},
      } = getOr({}, [name, "selectedOption"])(userChoices);

      return imageBadges.map((imageBadge) => {
        return {
          label,
          ...imageBadge,
          details,
          video,
          position: imageBadgePosition || position,
        };
      });
    })
  )(state);
}
